import React from 'react'
import { UnstableChip as Chip } from '@diversioteam/diversio-ds'

import { useDuplicatePulseSurveyFromTemplate } from 'hooks/pulseSurveys/useDuplicatePulseSurveyFromTemplate'

import { TemplateItemProps } from './templateItem.types'
import * as S from './templateItem.styles'

export const TemplateItem = ({
    uuid,
    title,
    description,
    short_description: shortDescription,
    is_popular: isPopular,
    ...props
}: TemplateItemProps) => {
    const { mutate } = useDuplicatePulseSurveyFromTemplate()

    const handleClickTemplate = () => {
        mutate({
            template: uuid,
        })
    }

    return (
        <S.TemplateItemWrapper onClick={() => handleClickTemplate()} role="button" {...props}>
            <S.Title>{title}</S.Title>

            <S.Description>{shortDescription || description}</S.Description>

            {isPopular && (
                <S.ChipsListItem>
                    <Chip label="Popular" size="xsmall" />
                </S.ChipsListItem>
            )}
            <S.Thumbnail />
        </S.TemplateItemWrapper>
    )
}
